import React from 'react';
import styles from './ErrorDisplay.module.css';
import { KatButton, KatIcon } from '@amzn/katal-react';
import { DEFAULT_SUPPORT_EMAIL } from 'src/constants';

interface ErrorDisplayProps {
  /**
   * Optional support email address
   */
  supportEmail?: string;
  /**
   * Optional callback for returning to homepage
   */
  onNavigateHome: () => void;
}

/**
 * A full-screen error display component that shows an error message with a link to the homepage
 */
export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  supportEmail = DEFAULT_SUPPORT_EMAIL,
  onNavigateHome,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <KatIcon name="error" size="xlarge" className={styles.icon} />
        <h1 className={styles.title}>Something went wrong</h1>
        <div className={styles.message} aria-live="assertive">
          Please contact <a href={`mailto:${supportEmail}`}>{supportEmail}</a> for support.
        </div>
        <div className={styles.actions}>
          <KatButton variant="primary" onClick={onNavigateHome} data-testid="home-button">
            Return to Homepage
          </KatButton>
        </div>
      </div>
    </div>
  );
};
